export const MOBILE_PAGE_CONFIG = {
  title: 'Churn',
  titleCN: '流失',
  subTitle: '',
  subTitleCN: '',
  path: '/engagement/churn',
  defaultTab: 'all_user',
  tabList: [
    {
      id: 'all_user',
      tabName: 'All Users',
      tabNameCN: '所有用户流失',
      isHaveNotification: true,
      notificationPath: '/engagement/churn/allUsers',
      path: '/engagement/churn/allUsers',
      logConfig: {
        pageId: '200901',
        pageName: 'engaementChurnAllUsers',
        extInfo: 'engaementChurnAllUsers',
        pagePath: '/engagement/churn/allUsers',
      },
      filters: [
        {
          name: 'ChurnAllFilter',
          isOpenSticky: true,
          isHaveFilterSave: true,
          filterPath: '/engagement/churn/allUsers',
          componentList: [
            {
              name: 'ChurnAllUserService',
              className: '',
              type: 'view',
              style: {},
              props: {
                config: {
                  api: '/api/v1/dashboard/engagement/churn/metrics',
                  dataKey: 'metrics'
                }
              },
              children: [
                {
                  name: 'CommonRow',
                  className: '',
                  type: 'layout',
                  style: { marginTop: '10px' },
                  props: {},
                  children: [
                    {
                      name: 'CommonCol',
                      className: '',
                      type: 'layout',
                      style: {},
                      props: {
                        w: 12
                      },
                      children: [
                        {
                          name: 'ChurnUsersCo',
                          className: '',
                          type: '',
                          style: {},
                          props: {
                            apiDataKey: 'metrics',
                            config: {
                              Week: {
                                title: 'Weekly Churn Users and Churn%',
                                titleCn: '周流失用户和流失率',
                                titleDes: [
                                  {
                                    title: 'Weekly Churn Users',
                                    titleCn: '周流失用户',
                                    isRainbow: true,
                                    rainbowKey: 'Weekly Churn Users',
                                    contentEn: '',
                                    contentCn: ''
                                  },
                                  {
                                    title: 'Weekly Churn%',
                                    titleCn: '周流失率',
                                    isRainbow: true,
                                    rainbowKey: 'Weekly Churn%',
                                    contentEn: '',
                                    contentCn: ''
                                  }
                                ],
                                tab: {
                                  value: 'accChurn',
                                  list: []
                                },
                                metricsKey: 'weekly_churn_metric_list',
                                table: [
                                  {
                                    title: 'Date',
                                    titleCn: '日期',
                                    dataType: 'date',
                                    key: 'date',
                                    align: 'left',
                                    fixed: 'left',
                                    width: 100,
                                  },
                                  {
                                    title: 'Weekly Churn Users',
                                    titleCn: '周流失用户',
                                    dataType: 'number',
                                    key: 'weekly_churn_users',
                                    align: 'right',
                                    width: 150,
                                  },
                                  {
                                    title: 'Weekly Churn%',
                                    titleCn: '周流失率',
                                    dataType: 'percent',
                                    key: 'weekly_churn_ratio',
                                    align: 'right',
                                    width: 150,
                                  }
                                ],
                                toolTip: {
                                  title: '',
                                  titleCn: '',
                                  metrics: '',
                                  metricsCn: '',
                                  dataType: ''
                                },
                                chart: [
                                  {
                                    title: 'Weekly Churn Users',
                                    titleCn: '周流失用户',
                                    dataType: 'number',
                                    key: 'weekly_churn_users',
                                    type: 'bar'
                                  },
                                  {
                                    title: 'Weekly Churn%',
                                    titleCn: '周流失率',
                                    dataType: 'percent',
                                    key: 'weekly_churn_ratio',
                                    type: 'line'
                                  }
                                ],
                                hideConfig: {}
                              },
                              Month: {
                                title: 'Monthly Churn Users',
                                titleCn: '月流失用户',
                                titleDes: [
                                  {
                                    title: '',
                                    titleCn: '',
                                    isRainbow: true,
                                    rainbowKey: 'Monthly Churn Users',
                                    contentEn: '',
                                    contentCn: ''
                                  }
                                ],
                                tab: {
                                  value: 'accChurn',
                                  list: []
                                },
                                metricsKey: 'monthly_churn_users_list',
                                table: [
                                  {
                                    title: 'Date',
                                    titleCn: '日期',
                                    dataType: 'date',
                                    key: 'date',
                                    align: 'left',
                                    fixed: 'left',
                                    width: 100,
                                  },
                                  {
                                    title: 'This Month',
                                    titleCn: '当月',
                                    dataType: 'number',
                                    key: 'this_value',
                                    align: 'right',
                                    width: 150,
                                  },
                                  {
                                    title: 'SMLY',
                                    titleCn: '去年同期',
                                    dataType: 'number',
                                    key: 'smly',
                                    align: 'right',
                                    width: 150,
                                  }
                                ],
                                toolTip: {
                                  title: '',
                                  titleCn: '',
                                  metrics: '',
                                  metricsCn: '',
                                  dataType: ''
                                },
                                chart: [
                                  {
                                    title: 'This Month',
                                    titleCn: '当月',
                                    dataType: 'number',
                                    key: 'this_value',
                                    type: 'bar'
                                  },
                                  {
                                    title: 'SMLY',
                                    titleCn: '去年同期',
                                    dataType: 'number',
                                    key: 'smly',
                                    type: 'bar'
                                  }
                                ],
                                hideConfig: {}
                              }
                            }
                          }
                        }
                      ]
                    },
                    {
                      name: 'CommonCol',
                      className: '',
                      type: 'layout',
                      style: {},
                      props: {
                        w: 12
                      },
                      children: [
                        {
                          name: 'ChurnUsersCo',
                          className: '',
                          type: '',
                          style: {},
                          props: {
                            apiDataKey: 'metrics',
                            config: {
                              Week: {
                                title: 'Biweekly Churn Users and Churn%',
                                titleCn: '双周流失用户和流失率',
                                titleDes: [
                                  {
                                    title: '',
                                    titleCn: '',
                                    isRainbow: true,
                                    rainbowKey: 'Biweekly Churn Users and Churn%',
                                    contentEn: '',
                                    contentCn: ''
                                  }
                                ],
                                tab: {
                                  value: 'accChurn',
                                  list: []
                                },
                                metricsKey: 'biweekly_churn_metric_list',
                                table: [
                                  {
                                    title: 'Date',
                                    titleCn: '日期',
                                    dataType: 'date',
                                    key: 'date',
                                    align: 'left',
                                    fixed: 'left',
                                    width: 100,
                                  },
                                  {
                                    title: 'Biweekly Churn Users',
                                    titleCn: '双周流失用户',
                                    dataType: 'number',
                                    key: 'weekly_churn_users',
                                    align: 'right',
                                    width: 150,
                                  },
                                  {
                                    title: 'Biweekly Churn%',
                                    titleCn: '双周流失率',
                                    dataType: 'percent',
                                    key: 'weekly_churn_ratio',
                                    align: 'right',
                                    width: 150,
                                  }
                                ],
                                toolTip: {
                                  title: '',
                                  titleCn: '',
                                  metrics: '',
                                  metricsCn: '',
                                  dataType: ''
                                },
                                chart: [
                                  {
                                    title: 'Biweekly Churn Users',
                                    titleCn: '双周流失用户',
                                    dataType: 'number',
                                    key: 'weekly_churn_users',
                                    type: 'bar'
                                  },
                                  {
                                    title: 'Biweekly Churn%',
                                    titleCn: '双周流失率',
                                    dataType: 'percent',
                                    key: 'weekly_churn_ratio',
                                    type: 'line'
                                  }
                                ],
                                hideConfig: {}
                              },
                              Month: {
                                title: 'Monthly Churn%',
                                titleCn: '月流失率',
                                titleDes: [
                                  {
                                    title: '',
                                    titleCn: '',
                                    isRainbow: true,
                                    rainbowKey: 'Monthly Churn%',
                                    contentEn: '',
                                    contentCn: ''
                                  }
                                ],
                                tab: {
                                  value: 'accChurn',
                                  list: []
                                },
                                metricsKey: 'monthly_churn_ratio_list',
                                table: [
                                  {
                                    title: 'Date',
                                    titleCn: '日期',
                                    dataType: 'date',
                                    key: 'date',
                                    align: 'left',
                                    fixed: 'left',
                                    width: 100,
                                  },
                                  {
                                    title: 'This Month',
                                    titleCn: '当月',
                                    dataType: 'percent',
                                    key: 'this_value',
                                    align: 'right',
                                    width: 150,
                                  },
                                  {
                                    title: 'SMLY',
                                    titleCn: '去年同期',
                                    dataType: 'percent',
                                    key: 'smly',
                                    align: 'right',
                                    width: 150,
                                  }
                                ],
                                toolTip: {
                                  title: '',
                                  titleCn: '',
                                  metrics: '',
                                  metricsCn: '',
                                  dataType: ''
                                },
                                chart: [
                                  {
                                    title: 'This Month',
                                    titleCn: '当月',
                                    dataType: 'percent',
                                    key: 'this_value',
                                    type: 'bar'
                                  },
                                  {
                                    title: 'SMLY',
                                    titleCn: '去年同期',
                                    dataType: 'percent',
                                    key: 'smly',
                                    type: 'bar'
                                  }
                                ],
                                hideConfig: {},
                                otherConfigFunc: {
                                  y1: {
                                    type: 'percent'
                                  }
                                }
                              }
                            }
                          }
                        }
                      ]
                    }
                  ]
                },
              ]
            },
            {
              name: "CommonRow",
              className: "",
              type: "layout",
              style: {},
              props: {},
              children: [
                {
                  name: "RankListTabCo",
                  className: "",
                  style: {},
                  type: "view",
                  data: {
                    regionDataType: "country",
                    tabOrder: [
                      "country",
                      "region",
                      "zone"
                    ]
                  },
                  children: [
                    {
                      name: "CommonRankListCo",
                      className: "",
                      type: "view",
                      style: {},
                      props: {
                        config: {
                          api: "/api/v1/dashboard/engagement/churn/countries_region_zone",
                          metric: "churn",
                          haveCalBubble: false,
                          isUserQuota: true,
                          componentMetrics: {
                            responeseValueName: "churn",
                            reqMetricKey: "churn",
                            metricKey: "churn",
                            enName: "Churn",
                            cnName: "流失用户",
                            enWeekName: "Churn",
                            cnWeekName: "流失",
                            enMonthName: "Churn",
                            cnMonthName: "流失",
                            rangeEnName: "Sum Churn",
                            rangeCnName: "流失总数",
                            rangeEnWeekName: "Sum Churn",
                            rangeCnWeekName: "流失总数",
                            rangeEnMonthName: "Sum Churn",
                            rangeCnMonthName: "流失总数",
                            prefix: "",
                            type: "int",
                            decimal: 0,
                            percentDecimals: 0,
                            ratioField: "churn_dop",
                            shareKey: "Share",
                            shareKeyCn: "全局占比",
                            enTitleName: 'Churn',
                            cnTitleName: '流失用户',
                            extraComponentMetrics: [
                              {
                                reqMetricKey: "ave_churn",
                                metricKey: "ave_churn",
                                enName: "Churn%",
                                cnName: "流失率",
                                enWeekName: "Churn%",
                                cnWeekName: "流失率",
                                enMonthName: "Churn%",
                                cnMonthName: "流失率",
                                rangeEnName: "Avg.Churn%",
                                rangeCnName: "平均流失率",
                                rangeEnWeekName: "Avg.Churn%",
                                rangeCnWeekName: "平均流失率",
                                rangeEnMonthName: "Avg.Churn%",
                                rangeCnMonthName: "平均流失率",
                                prefix: "",
                                dataType: "twoDecimalPercent",
                                type: "percent",
                                decimal: 0,
                                percentDecimals: 2,
                                ratioField: "",
                              }
                            ],
                            comShowConfig: {
                              isHaveBar: true,
                              isHaveLine: true,
                              isHavePie: true,
                              isHaveShare: true
                            },
                            showConfig: {
                              showTable: true,
                              showChart: true
                            }
                          },
                          comConfig: {
                            isHaveBar: true,
                            isHaveLine: true,
                            isHavePie: true,
                            isHaveShare: true
                          },
                          showConfig: {
                            showTable: true,
                            showChart: true
                          }
                        }
                      }
                    }
                  ]
                }
              ]
            },
            {
              name: 'CommonRow',
              className: '',
              type: 'layout',
              style: { marginTop: '10px' },
              props: {},
              children: [
                {
                  name: 'CommonCol',
                  className: '',
                  type: 'layout',
                  style: {},
                  props: {
                    w: 12
                  },
                  children: [
                    {
                      name: 'ChurnAllUserService',
                      className: '',
                      type: 'view',
                      style: {},
                      props: {
                        config: {
                          api: '/api/v1/dashboard/engagement/churn/payer_churn',
                          dataKey: 'payer_churn'
                        }
                      },
                      children: [
                        {
                          name: 'ChurnUsersCo',
                          className: '',
                          type: '',
                          style: {},
                          props: {
                            apiDataKey: 'payer_churn',
                            config: {
                              Week: {
                                title: 'Weekly Payer Churn',
                                titleCn: '周付费流失用户',
                                titleDes: [],
                                tab: {
                                  value: 'accChurn',
                                  list: []
                                },
                                metricsKey: 'payer_churn_list',
                                table: [
                                  {
                                    title: 'Date',
                                    titleCn: '日期',
                                    dataType: 'date',
                                    key: 'date',
                                    align: 'left',
                                    fixed: 'left',
                                    width: 100,
                                  },
                                  {
                                    title: 'Weekly Payer Churn',
                                    titleCn: '周付费流失用户',
                                    dataType: 'number',
                                    key: 'weekly_payer_churn',
                                    align: 'right',
                                    width: 150,
                                  },
                                  {
                                    title: 'Weekly Payer Churn%',
                                    titleCn: '周付费用户流失率',
                                    dataType: 'percent',
                                    key: 'weekly_payer_churn_ratio',
                                    align: 'right',
                                    width: 150,
                                  }
                                ],
                                toolTip: {
                                  title: '',
                                  titleCn: '',
                                  metrics: '',
                                  metricsCn: '',
                                  dataType: ''
                                },
                                chart: [
                                  {
                                    title: 'Weekly Payer Churn',
                                    titleCn: '周付费流失用户',
                                    dataType: 'number',
                                    key: 'weekly_payer_churn',
                                    type: 'bar'
                                  },
                                  {
                                    title: 'Weekly Payer Churn%',
                                    titleCn: '周付费用户流失率',
                                    dataType: 'percent',
                                    key: 'weekly_payer_churn_ratio',
                                    type: 'line'
                                  }
                                ],
                                hideConfig: {},
                                height: 345
                              },
                              Month: {
                                title: 'Monthly Payer Churn',
                                titleCn: '月付费流失用户',
                                titleDes: [],
                                tab: {
                                  value: 'accChurn',
                                  list: []
                                },
                                metricsKey: 'payer_churn_list',
                                table: [
                                  {
                                    title: 'Date',
                                    titleCn: '日期',
                                    dataType: 'date',
                                    key: 'date',
                                    align: 'left',
                                    fixed: 'left',
                                    width: 100,
                                  },
                                  {
                                    title: 'Monthly Payer Churn',
                                    titleCn: '月付费流失用户',
                                    dataType: 'number',
                                    key: 'weekly_payer_churn',
                                    align: 'right',
                                    width: 150,
                                  },
                                  {
                                    title: 'Monthly Payer Churn%',
                                    titleCn: '月付费用户流失率',
                                    dataType: 'percent',
                                    key: 'weekly_payer_churn_ratio',
                                    align: 'right',
                                    width: 150,
                                  }
                                ],
                                toolTip: {
                                  title: '',
                                  titleCn: '',
                                  metrics: '',
                                  metricsCn: '',
                                  dataType: ''
                                },
                                chart: [
                                  {
                                    title: 'Monthly Payer Churn',
                                    titleCn: '月付费流失用户',
                                    dataType: 'number',
                                    key: 'weekly_payer_churn',
                                    type: 'bar'
                                  },
                                  {
                                    title: 'Monthly Payer Churn%',
                                    titleCn: '月付费用户流失率',
                                    dataType: 'percent',
                                    key: 'weekly_payer_churn_ratio',
                                    type: 'line'
                                  }
                                ],
                                otherConfigFunc: {
                                  y2: {
                                    show: true,
                                    type: 'percent'
                                  }
                                },
                                hideConfig: {},
                                height: 345
                              }
                            }
                          }
                        }
                      ]
                    },
                  ]
                },
                {
                  name: 'CommonCol',
                  className: 'tea-grid__box',
                  type: 'layout',
                  style: {},
                  props: {
                    w: 12
                  },
                  children: [
                    {
                      name: 'ChurnAllUserService',
                      className: '',
                      type: 'view',
                      style: {
                        height: "421px"
                      },
                      props: {
                        config: {
                          api: '/api/v1/dashboard/engagement/churn/level_distribution',
                          dataKey: 'level_distribution'
                        }
                      },
                      data: {
                        byType: 'accumulated'
                      },
                      children: [
                        {
                          name: 'ChurnLevelDistributionCo',
                          className: '',
                          type: '',
                          style: {},
                          props: {
                            apiDataKey: 'level_distribution',
                            config: {
                              Week: {
                                title: 'Weekly Churn level Distribution',
                                titleCn: '周流失用户等级构成',
                                titleDes: [],
                                tab: {
                                  value: 'accumulated',
                                  list: [{
                                    text: 'Accumulated',
                                    textCn: '聚合呈现',
                                    value: 'accumulated'
                                  },{
                                    text: 'Top 10 Level',
                                    textCn: '流失用户 Top 10 等级',
                                    value: 'specific'
                                  }]
                                },
                                metricsKey: 'churn_level_distribution',
                                toolTip: {
                                  title: 'Level',
                                  titleCn: '等级',
                                  metrics: 'Churn Users',
                                  metricsCn: '流失用户',
                                  dataType: ''
                                },
                                hideConfig: {
                                  eyes: true
                                }
                              },
                              Month: {
                                title: 'Monthly Churn level Distribution',
                                titleCn: '月流失用户等级构成',
                                titleDes: [],
                                tab: {
                                  value: 'accumulated',
                                  list: [{
                                    text: 'Accumulated',
                                    textCn: '聚合呈现',
                                    value: 'accumulated'
                                  },{
                                    text: 'Top 10 Level',
                                    textCn: '流失用户 Top 10 等级',
                                    value: 'specific'
                                  }]
                                },
                                metricsKey: 'churn_level_distribution',
                                toolTip: {
                                  title: 'Level',
                                  titleCn: '等级',
                                  metrics: 'Churn Users',
                                  metricsCn: '流失用户',
                                  dataType: ''
                                },
                                hideConfig: {
                                  eyes: true
                                }
                              }
                            },
                            dataKey: 'byType'
                          }
                        }
                      ]
                    },
                  ]
                },
              ]
            },
            {
              name: "OverallTableCo",
              className: "margin-t-20",
              type: "view",
              style: { marginBottom: '-10px' },
              props: {
                config: {
                  isHaveDiff: false,
                  useTime: true,
                  showStatistic: ["avg"],
                  slotConfig: {
                    isShowValueType: false,
                    isShowMetricsSettings: false,
                    isShowProgressBar: false,
                    isShowdownloadConfig: false,
                  },
                  valueTypeConfig: {
                    valueType: "dod",
                  },
                  api: {
                    tableApi: "/api/v1/dashboard/engagement/churn/overall_performance",
                    tableDownloadApi: "/api/v1/dashboard/engagement/churn/overall_performance/download",
                  },
                  titleConfig: {
                    Week: {
                      titleEn: "Weekly/Biweekly Churn Users Details",
                      titleCn: "周/双周流失用户指标",
                    },
                    Month: {
                      titleEn: "Monthly Churn Users Details",
                      titleCn: "月流失用户指标",
                    }
                  },
                  componentMetricsConfig: {
                    Week: [
                      {
                        metricKey: "Weekly Churn Users",
                        reqMetricKey: "Weekly Churn Users",
                        enPercentWidth: 205,
                        cnPercentWidth: 205,
                        enWidth: 205,
                        cnWidth: 205,
                        enName: "Weekly Churn Users",
                        cnName: "周流失用户",
                        rainbowKey: "Weekly Churn Users",
                        type: "int",
                        decimal: 0,
                        percentDecimals: 1
                      },
                      {
                        metricKey: "Weekly Churn%",
                        reqMetricKey: "Weekly Churn%",
                        enPercentWidth: 165,
                        cnPercentWidth: 165,
                        enWidth: 165,
                        cnWidth: 165,
                        enName: "Weekly Churn%",
                        cnName: "周流失率",
                        rainbowKey: "Weekly Churn%",
                        type: "percent",
                        decimal: 2,
                        percentDecimals: 1,
                        hideProgressBar: true
                      },
                      {
                        metricKey: "Biweekly Churn Users",
                        reqMetricKey: "Biweekly Churn Users",
                        enPercentWidth: 215,
                        cnPercentWidth: 215,
                        enWidth: 215,
                        cnWidth: 215,
                        enName: "Biweekly Churn Users",
                        cnName: "双周流失用户",
                        rainbowKey: "Biweekly Churn Users",
                        type: "int",
                        decimal: 0,
                        percentDecimals: 1
                      },
                      {
                        metricKey: "Biweekly Churn%",
                        reqMetricKey: "Biweekly Churn%",
                        enPercentWidth: 185,
                        cnPercentWidth: 185,
                        enWidth: 185,
                        cnWidth: 185,
                        enName: "Biweekly Churn%",
                        cnName: "双周流失率",
                        rainbowKey: "Biweekly Churn%",
                        type: "percent",
                        decimal: 2,
                        percentDecimals: 1,
                        hideProgressBar: true
                      },
                      {
                        metricKey: "Weekly Payer Churn",
                        reqMetricKey: "Weekly Payer Churn",
                        enPercentWidth: 205,
                        cnPercentWidth: 205,
                        enWidth: 205,
                        cnWidth: 205,
                        enName: "Weekly Payer Churn",
                        cnName: "周付费流失用户",
                        rainbowKey: "Weekly Payer Churn",
                        type: "int",
                        decimal: 0,
                        percentDecimals: 1
                      },
                      {
                        metricKey: "Weekly Payer Churn%",
                        reqMetricKey: "Weekly Payer Churn%",
                        enPercentWidth: 215,
                        cnPercentWidth: 215,
                        enWidth: 215,
                        cnWidth: 215,
                        enName: "Weekly Payer Churn%",
                        cnName: "周付费用户流失率",
                        rainbowKey: "Weekly Payer Churn%",
                        type: "percent",
                        decimal: 2,
                        percentDecimals: 1,
                        hideProgressBar: true
                      }
                    ],
                    Month: [
                      {
                        metricKey: "Monthly Churn Users",
                        reqMetricKey: "Monthly Churn Users",
                        enPercentWidth: 205,
                        cnPercentWidth: 205,
                        enWidth: 205,
                        cnWidth: 205,
                        enName: "Monthly Churn Users",
                        cnName: "月流失用户",
                        rainbowKey: "Monthly Churn Users",
                        type: "int",
                        decimal: 0,
                        percentDecimals: 1
                      },
                      {
                        metricKey: "Monthly Churn%",
                        reqMetricKey: "Monthly Churn%",
                        enPercentWidth: 165,
                        cnPercentWidth: 165,
                        enWidth: 165,
                        cnWidth: 165,
                        enName: "Monthly Churn%",
                        cnName: "月流失率",
                        rainbowKey: "Monthly Churn%",
                        type: "percent",
                        decimal: 2,
                        percentDecimals: 1,
                        hideProgressBar: true
                      },
                      {
                        metricKey: "Monthly Payer Churn",
                        reqMetricKey: "Monthly Payer Churn",
                        enPercentWidth: 205,
                        cnPercentWidth: 205,
                        enWidth: 205,
                        cnWidth: 205,
                        enName: "Monthly Payer Churn",
                        cnName: "月付费流失用户",
                        rainbowKey: "Monthly Payer Churn",
                        type: "int",
                        decimal: 0,
                        percentDecimals: 1
                      },
                      {
                        metricKey: "Monthly Payer Churn%",
                        reqMetricKey: "Monthly Payer Churn%",
                        enPercentWidth: 215,
                        cnPercentWidth: 215,
                        enWidth: 215,
                        cnWidth: 215,
                        enName: "Monthly Payer Churn%",
                        cnName: "月付费用户流失率",
                        rainbowKey: "Monthly Payer Churn%",
                        type: "percent",
                        decimal: 2,
                        percentDecimals: 1,
                        hideProgressBar: true
                      }
                    ]
                  },
                  accumulatesConfig: {
                    zone: 170,
                    region: 260,
                    country: 260,
                    channel: 170,
                    system: 170,
                    language: 170
                  },
                  pageSizeOptions: [10, 20, 30, 40, 50],
                  formatType: 'playtime'
                }
              }
            },
          ]
        },
      ]
    },
    {
      id: 'new_user',
      tabName: 'New Users',
      tabNameCN: '新进用户流失',
      isHaveNotification: true,
      notificationPath: '/engagement/churn/newUsers',
      path: '/engagement/churn/newUsers',
      logConfig: {
        pageId: '200902',
        pageName: 'engaementChurnNewUsers',
        extInfo: 'engaementChurnNewUsers',
        pagePath: '/engagement/churn/newUsers',
      },
      filters: [
        {
          name: 'ChurnNewFilter',
          isOpenSticky: true,
          isHaveFilterSave: true,
          filterPath: '/engagement/churn/newUsers',
          componentList: [
            {
              name: 'ChurnAllUserService',
              className: '',
              type: 'view',
              style: {},
              props: {
                config: {
                  api: '/api/v1/dashboard/engagement/churn/first_day_distribution',
                  dataKey: 'first_day_distribution'
                }
              },
              children: [
                {
                  name: 'CommonRow',
                  className: '',
                  type: 'layout',
                  style: { marginTop: '10px' },
                  props: {},
                  children: [
                    {
                      name: 'CommonCol',
                      className: '',
                      type: 'layout',
                      style: {},
                      props: {
                        w: 24
                      },
                      children: [
                        {
                          name: 'ChurnUsersOnlineTimeDistributionCo',
                          className: '',
                          type: '',
                          style: {},
                          props: {
                            apiDataKey: 'first_day_distribution',
                            config: {
                              title: 'First Day Churn Users Playtime Distribution',
                              titleCn: '首日流失用户在线时长分布',
                              titleDes: [
                                {
                                  title: '',
                                  titleCn: '',
                                  isRainbow: true,
                                  rainbowKey: 'First Day Churn Users Playtime Distribution',
                                  contentEn: '',
                                  contentCn: ''
                                }
                              ],
                              tab: {
                                value: 'accChurn',
                                list: []
                              },
                              metricsKey: 'otd_list',
                              toolTip: {
                                title: '',
                                titleCn: '',
                                metrics: '',
                                metricsCn: '',
                                dataType: ''
                              },
                              hideConfig: {
                                eyes: true
                              },
                              height: 400
                            }
                          }
                        }
                      ]
                    }
                  ]
                },
              ]
            },
            {
              name: 'TableLevelCo',
              className: '',
              type: 'view',
              style: {},
              props: {
                config: {
                  api: {
                    tableApi: '/api/v1/dashboard/engagement/churn/table',
                    tableDownloadApi: '/api/v1/dashboard/engagement/churn/table/download',
                  },
                  componentMetrics: [
                    {
                      code: 'register',
                      title: 'Registered Users',
                      titleCn: '新进用户',
                      width: 180,
                      align: 'right',
                      features: { sortable: true }
                    },
                  ],
                  defaultMetrics: [
                    {
                      code: 'tracking_day',
                      title: 'Tracking Day',
                      titleCn: '关键日',
                      width: 150,
                      align: 'right',
                      features: { sortable: true }
                    }
                  ],
                  keyDaysConfig: ["1", "7", "14"],
                  title: 'Churn Tracking for New Register Users Level',
                  titleCN: '分等级查看新进用户的流失追踪',
                  titleDes: [
                    {
                      title: '',
                      titleCn: '',
                      isRainbow: true,
                      rainbowKey: 'Churn Tracking for New Register Users Level',
                      contentEn: '',
                      contentCn: ''
                    }
                  ],
                }
              }
            },
            {
              name: 'ChurnAllUserService',
              className: '',
              type: 'view',
              style: {},
              props: {
                config: {
                  api: '/api/v1/dashboard/engagement/churn/linechart',
                  dataKey: 'linechart'
                },
              },
              data: {
                trackingFilter: {}
              },
              children: [
                {
                  name: 'CommonRow',
                  className: '',
                  type: 'layout',
                  style: { marginTop: '10px' },
                  props: {},
                  children: [
                    {
                      name: 'CommonCol',
                      className: '',
                      type: 'layout',
                      style: {},
                      props: {
                        w: 24
                      },
                      children: [
                        {
                          name: 'TrackingDayCo',
                          className: '',
                          type: '',
                          style: {},
                          props: {
                            apiDataKey: 'linechart',
                            config: {
                              title: 'Different Date of New Register Users Level Churn on the Same Tracking Day',
                              titleCn: '不同注册日期的用户在同一个流失窗口下各个等级流失趋势',
                              titleDes: [],
                              tab: {
                                value: 'accChurn',
                                list: []
                              },
                              toolTip: {
                                title: 'Tracking Day',
                                titleCn: '关键日',
                                metrics: '',
                                metricsCn: '',
                                dataType: ''
                              },
                              hideConfig: {},
                              otherConfigFunc: {
                              },
                              table: [
                                {
                                  title: 'Level',
                                  titleCn: '日期',
                                  dataType: 'string',
                                  key: 'level',
                                  align: 'right',
                                  width: 100,
                                },
                                {
                                  title: '',
                                  titleCn: '',
                                  titlePre: '',
                                  titleEnd: 'Churn%',
                                  titleEndCn: '流失率',
                                  titleKey: 'dayOne',
                                  dataType: 'percent',
                                  key: 'dayOne',
                                  align: 'right',
                                  width: 100,
                                },
                                {
                                  title: '',
                                  titleCn: '',
                                  titlePre: '',
                                  titleEnd: 'Churn%',
                                  titleEndCn: '流失率',
                                  titleKey: 'dayTwo',
                                  dataType: 'percent',
                                  key: 'dayTwo',
                                  align: 'right',
                                  width: 100,
                                },
                              ],
                              chart: [
                                {
                                  title: '',
                                  titleCn: '',
                                  titleKey: 'dayOne',
                                  dataType: 'percent',
                                  key: 'dayOne',
                                  type: 'bar'
                                },
                                {
                                  title: '',
                                  titleCn: '',
                                  titleKey: 'dayTwo',
                                  dataType: 'percent',
                                  key: 'dayTwo',
                                  type: 'bar'
                                }
                              ]
                            },
                            dataKey: 'trackingFilter',
                            height: 400
                          }
                        }
                      ]
                    }
                  ]
                }
              ]
            },
          ]
        }
      ]
    }
  ],
};